/**
 * Pending-intent plumbing shared by the guest flows (upload, writer):
 * store the user's intent right before the auth wall, replay it exactly
 * once after sign-in, then clear it. Keys live in sessionStorage so the
 * intent survives an OAuth redirect but never outlives the tab.
 */

// Legacy key kept byte-identical so in-flight upload sessions are unaffected.
export const PENDING_UPLOAD_SUBMIT_KEY = 'pendingUploadSubmit';
export const PENDING_WRITER_PROMPT_KEY = 'paperverse.pendingWriterPrompt';

export function storePendingIntent(key: string, value: string = 'true'): void {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // Private mode / storage disabled: the gate still works, the replay is lost.
  }
}

export function peekPendingIntent(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function clearPendingIntent(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}

/**
 * Read-and-clear in one step. Replays MUST use this (not peek + clear) so a
 * refresh or StrictMode remount mid-replay can never run the intent twice.
 */
export function takePendingIntent(key: string): string | null {
  const value = peekPendingIntent(key);
  if (value !== null) clearPendingIntent(key);
  return value;
}
